import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import {
    collection,
    getDocs,
    query,
    where
} from "firebase/firestore";

import { db } from "../firebase/firebase";

// import Footer from "../components/common/Footer";
import ImageModal from "../components/Gallery/ImageModal";
import VideoModal from "../components/Gallery/VideoModal";

import "../assets/css/galleryCategory.css";




console.log("gallery");
function GalleryCategory() {
       console.log("gallery2");
    const { category } = useParams();

    const [searchParams] = useSearchParams();
   console.log("gallery3");
    const type = searchParams.get("type") || "photos";

    const [galleryItems, setGalleryItems] = useState([]);

    const [loading, setLoading] = useState(true);
    const [selectedVideo, setSelectedVideo] = useState(null);

    const [selectedPhoto, setSelectedPhoto] = useState(null);
    useEffect(() => {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant"
    });
}, []);

    useEffect(() => {

        const loadGallery = async () => {

            setLoading(true);

            try {

                const collectionName =
                    type === "photos"
                        ? "photos"
                        : "videos";

                const categoryName = decodeURIComponent(category);

                const q = query(
                    collection(db, collectionName),
                    where("category", "==", categoryName)
                );

                const snapshot = await getDocs(q);

                const data = [];

                snapshot.forEach((doc) => {

                    data.push({

                        id: doc.id,

                        ...doc.data()

                    });

                });

                setGalleryItems(data);

            } catch (error) {

                console.log(error);

            } finally {

                setLoading(false);

            }

        };

        loadGallery();

    }, [category, type]);

    return (

        <section className="customer-gallery-category-page">

            <div className="customer-gallery-category-header">

                <h1 className="customer-gallery-category-title">

                    {decodeURIComponent(category)}

                </h1>

                <p className="customer-gallery-category-subtitle">

                    {type === "photos"
                        ? "Photo Gallery"
                        : "Video Gallery"}

                </p>

            </div>

            <div className="customer-gallery-category-grid">

                {loading ? (

                    <h2 className="customer-gallery-category-message">

                        Loading...

                    </h2>

                ) : galleryItems.length === 0 ? (

                    <h2 className="customer-gallery-category-message">

                        No {type} Available

                    </h2>

                ) : (

                    galleryItems.map((item) => (

                        <div
                            key={item.id}
                            className="customer-gallery-category-card"
                        >

                            {type === "photos" ? (

                              <div
    className="gallery-photo-wrapper"
    onClick={() =>
        setSelectedPhoto({
            imageUrl: item.imageUrl,
            title: item.title,
            category: item.category
        })
    }
>

    <img
        src={item.imageUrl}
        alt={item.title}
        className="customer-gallery-category-image"
    />

    <div className="gallery-photo-overlay">

      

        <div className="gallery-photo-info">

            <span>{item.category}</span>

            <h3>{item.title}</h3>

            <p>Story Line Studios</p>

        </div>

    </div>

</div>

                            ) : (
<div
    className="gallery-video-wrapper"
    onClick={() => setSelectedVideo(item)}
>

    <video
    className="customer-gallery-category-video"
    muted
    preload="metadata"
>
    <source
        src={item.videoUrl}
        type="video/mp4"
    />
</video>

<div className="gallery-photo-overlay">

    <div className="gallery-premium-badge">
        LUXURY FILM
    </div>

    <div className="gallery-view-button">
        ▶
    </div>

</div>
    <div className="gallery-play-icon">
        ▶
    </div>

    <div className="gallery-video-info">

        <span className="gallery-video-category">
            {item.category}
        </span>

        <h3 className="gallery-video-title">
            {item.title}
        </h3>

        <p className="gallery-video-description">
            Cinematic storytelling crafted with elegance and timeless memories.
        </p>

    </div>

</div>
                            )}

                        </div>

                    ))

                )}

            </div>

            <ImageModal
                photo={selectedPhoto}
                onClose={() => setSelectedPhoto(null)}
            />
            <VideoModal
    video={selectedVideo}
    onClose={() => setSelectedVideo(null)}
/>
            {/* <Footer /> */}

        </section>
       
    );

}

export default GalleryCategory;